import './MultipleImage.css';
import React from 'react';
import { injectImageResolution } from '../../../utils';
import LazyPicture from '../../atoms/LazyPicture';
const MultipleImage = _ref => {
  let {
    imgSrc1,
    alt1,
    imgSrc2,
    alt2,
    rtl
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: rtl ? rtlStyles : ltrStyles
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: `section-detail-content__first__picture`
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: `${injectImageResolution(imgSrc1, 340, 440)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(imgSrc1, 158, 200)}`,
    alt: alt1
  })), /*#__PURE__*/React.createElement(LazyPicture, {
    className: `section-detail-content__second__picture`
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: `${injectImageResolution(imgSrc2, 340, 440)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(imgSrc2, 158, 200)}`,
    alt: alt2
  })));
};
const rtlStyles = "r5nylsi";
const ltrStyles = "l18hddu0";
export default MultipleImage;